export default "__VITE_ASSET__5bsalZ$9__"